<template>
  <a-layout>
    <drawer v-if="isMobile" :openDrawer="mobileMenuOpen" :showHandler="false" @change="onDrawerChange">
      <sider-menu :theme="theme" :menuData="menuData" :collapsed="false" :collapsible="false" @menuSelect="onMenuSelect"/>
    </drawer>
    <sider-menu :theme="theme" v-else-if="layout === 'side'" :menuData="menuData" :collapsed="collapsed" :collapsible="true" />
    <drawer :openDrawer="settingBar" placement="right" :showHandler="false" @change="setSettingBar">
      <setting/>
    </drawer>
    <a-layout :style="{ paddingLeft: paddingLeft }">
      <global-header :menuData="menuData" :collapsed="isMobile ? !mobileMenuOpen : collapsed" @toggleCollapse="toggleCollapse" @menuSelect="onMenuSelect"/>
      <a-layout-content :style="{minHeight: minHeight, margin: '20px 14px 0'}" :class="fixHeader ? 'fixed-header-content' : null">
        <slot></slot>
      </a-layout-content>
      <a-layout-footer style="padding: .29rem 0" class="copyright">
        <global-footer :copyright="copyright"/>
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import GlobalHeader from './GlobalHeader'
import GlobalFooter from './GlobalFooter'
import Drawer from '~/tool/Drawer'
import SiderMenu from '~/menu/SiderMenu'
import Setting from '~/setting/Setting'
import { mapState, mapMutations } from 'vuex'
import { triggerWindowResizeEvent } from 'utils/common'

const minHeight = window.innerHeight - 64 - 24 - 66

export default {
  name: 'GlobalLayout',
  components: {Setting, SiderMenu, Drawer, GlobalFooter, GlobalHeader},
  data () {
    return {
      minHeight: minHeight + 'px',
      mobileMenuOpen: false,
      menuData: []
    }
  },
  computed: {
    collapsed () { return !this.sidebarOpened },
    paddingLeft () {
      return this.fixSiderbar && this.layout === 'side' && !this.isMobile ? `${this.sidebarOpened ? 256 : 80}px` : '0'
    },
    ...mapState({
      settingBar: state => state.setting.settingBar.opened,
      sidebarOpened: state => state.setting.sidebar.opened,
      isMobile: state => state.setting.isMobile,
      theme: state => state.setting.theme,
      layout: state => state.setting.layout,
      copyright: state => state.setting.copyright,
      fixSiderbar: state => state.setting.fixSiderbar,
      fixHeader: state => state.setting.fixHeader
    })
  },
  methods: {
    ...mapMutations({setSidebar: 'setting/setSidebar', setSettingBar: 'setting/setSettingBar'}),
    toggleCollapse () {
      if (this.isMobile) this.mobileMenuOpen = !this.mobileMenuOpen
      else this.setSidebar(!this.sidebarOpened)
      triggerWindowResizeEvent()
    },
    onDrawerChange (show) {
      this.mobileMenuOpen = show
    },
    onMenuSelect () {
      if (this.isMobile) this.mobileMenuOpen = false
    }
  },
  watch: {
    isMobile () { this.mobileMenuOpen = false }
  },
  mounted () {
    const routers = this.$db.get('USER_ROUTER') || []
    const root = Array.isArray(routers) ? routers.find((item) => item.path === '/') : null
    const children = (root && root.children) || []
    this.menuData = children.filter((menu) => {
      const meta = menu.meta || {}
      if (meta.isShow === undefined) {
        return true
      }
      return meta.isShow
    })
  }
}
</script>

<style lang="less" scoped>
  .setting{
    background-color: #1890ff;
    color: #fff;
    border-radius: 5px 0 0 5px;
    line-height: 40px;
    font-size: 22px;
    width: 40px;
    height: 40px;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  }
  .fixed-header-content {
    margin: 76px 12px 0 !important;
  }
</style>
